import { HostAPIEditorX } from './HostAPIEditorX';
export class HostAPIStudio extends HostAPIEditorX {
    constructor() {
        super(...arguments);
        this.getExternalPanelsPrivateAPI = () => {
            return this.platformApiMethods.editor.getExternalPanelsPrivateAPI();
        };
    }
}
//# sourceMappingURL=HostAPIStudio.js.map